import React from "react";
import { ShieldCheck, Award, Truck, ThumbsUp, Phone, User } from "lucide-react";
import { businessInfo } from "../mock";
import { Button } from "./ui/button";

const About = () => {
  return (
    <section id="about" className="py-20 lg:py-28 bg-black">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div className="relative">
          <div className="absolute -inset-4 bg-red-600/20 blur-3xl rounded-full" />
          <img
            src={businessInfo.cardUrl}
            alt="1/2 Fast Mobile Keys business card"
            className="relative w-full rounded-2xl border border-red-900/40 shadow-2xl shadow-red-950/40"
          />
          <div className="hidden md:flex absolute -bottom-6 -right-6 brand-card rounded-xl p-5 max-w-[240px] items-start gap-3 border-yellow-500/30">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-yellow-400 to-yellow-600 flex items-center justify-center shrink-0">
              <User className="w-5 h-5 text-black" strokeWidth={2.4} />
            </div>
            <div>
              <div className="text-yellow-300 text-xs font-bold uppercase tracking-widest">Owner</div>
              <div className="text-white font-bold text-lg leading-tight">{businessInfo.owner}</div>
              <div className="text-zinc-500 text-xs mt-0.5">Locally owned · Tri-State</div>
            </div>
          </div>
        </div>

        <div>
          <span className="text-yellow-400 font-bold uppercase tracking-[0.3em] text-xs">About</span>
          <h2 className="mt-3 text-white font-extrabold text-3xl lg:text-5xl tracking-tight heading-underline">
            Local. Honest. Always Answering.
          </h2>
          <p className="mt-6 text-zinc-300 text-lg leading-relaxed">
            I'm Shane Shannon, a one-man mobile operation based in Louisa, Kentucky. When you call 1/2 Fast Mobile Keys, you talk to me — not a call center. I bring the shop to your driveway, parking lot, or roadside, and I get you back on your way fast.
          </p>

          <div className="mt-8 grid sm:grid-cols-2 gap-4">
            <Feature icon={<Truck />} title="Fully Equipped Van" text="All the gear, ready every call." />
            <Feature icon={<Award />} title="Dealer-Beating Prices" text="Guaranteed lower than the dealer." />
            <Feature icon={<ShieldCheck />} title="Damage-Free Promise" text="Modern tools, no broken windows." />
            <Feature icon={<ThumbsUp />} title="Friendly Service" text="Straight talk, fair work, every time." />
          </div>

          <div className="mt-8">
            <Button asChild className="bg-brand-red text-white font-semibold h-12 px-6">
              <a href={`tel:${businessInfo.phoneRaw}`}>
                <Phone className="w-4 h-4 mr-2" />
                Talk to Shane directly
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

const Feature = ({ icon, title, text }) => (
  <div className="flex gap-3">
    <div className="w-10 h-10 shrink-0 rounded-md bg-red-950/60 border border-red-700/40 text-red-500 flex items-center justify-center">
      {React.cloneElement(icon, { className: "w-5 h-5", strokeWidth: 2.2 })}
    </div>
    <div>
      <div className="font-bold text-white">{title}</div>
      <div className="text-zinc-400 text-sm mt-0.5">{text}</div>
    </div>
  </div>
);

export default About;
